import { Button } from "~/components/ui/button";
import { Modal } from "~/components/ui/modal/modal";

interface ConfirmationDialogProps {
  open: boolean;
  onOpenChange?: (open: boolean) => void;
  title: string;
  description: string;
  confirmText?: string;
  cancelText?: string;
  variant?: "default" | "destructive";
  onConfirm: () => void;
  onCancel?: () => void;
  isLoading?: boolean;
}

/** Confirm-or-cancel modal in default style; ConfirmDialog is destructive by default. */
export function ConfirmationDialog({
  open,
  onOpenChange,
  title,
  description,
  confirmText = "Confirm",
  cancelText = "Cancel",
  variant = "default",
  onConfirm,
  onCancel,
  isLoading = false,
}: ConfirmationDialogProps) {
  const handleCancel = () => {
    onOpenChange?.(false);
  };

  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <Modal.Root
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          onCancel?.();
        }
        onOpenChange?.(isOpen);
      }}
    >
      <Modal.Panel>
        <Modal.Title>{title}</Modal.Title>
        <div className="flex h-16 w-16 items-center justify-center rounded-xl bg-brand-50">
          <span className="text-4xl text-orange-200">?</span>
        </div>
        <Modal.Description>{description}</Modal.Description>

        <div className="mt-4 flex justify-between gap-2">
          <Button onClick={handleCancel} disabled={isLoading}>
            {cancelText}
          </Button>
          <Button
            type="button"
            variant={variant === "destructive" ? "destructive" : "primary"}
            disabled={isLoading}
            onClick={handleConfirm}
          >
            {confirmText}
          </Button>
        </div>
      </Modal.Panel>
    </Modal.Root>
  );
}
